<template>
    <div>
        <div class="card mb-3"
                draggable
                @dragstart="startDrag($event, datas)">
            <div class="card-body" style="background: rgba(113,113,113,1)">
                <!-- <h5 class="card-title">Card title</h5>
                <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6> -->
                <p class="card-text text-light">{{datas.title}}</p>
                <div>
                    <div class="float-start fw-lighter" style="font-size:0.6rem; color:white">
                        <div>
                          Created by: {{datas.User.name}} On: {{new Date(datas.createdAt).getDate()}} / {{new Date(datas.createdAt).getMonth()+1}} / {{new Date(datas.createdAt).getFullYear()}}
                        </div>
                    </div>
                    <div class="float-end" style="font-size:0.7rem">
                        <a href="#" class="card-link"  @click.prevent="editForm" data-bs-toggle="modal" data-bs-target="#exampleModal"><i class="fas fa-pencil-alt text-info"></i></a>
                        <a href="#" class="card-link" @click.prevent="deleteTask" data-bs-toggle="modal" data-bs-target="#exampleModal"><i class="fas fa-eraser text-danger"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "cards",
    // components: { categories },
    props: ["datas","id"],
    data() {
        return {
        message: 'Hello world',
        };
    },
    methods : {
        editForm(){
            // console.log(this.datas,'cards')
            
                // console.log(localStorage.getItem('id'))
                // console.log(this.datas.UsersId)
                let userId = localStorage.getItem('id')
            if (userId == this.datas.UserId) {
                this.$emit('showModalEdit',this.datas)
            }else{
                this.$emit('showModalError')
            }
        },
        deleteTask(){
            // console.log(this.datas)
                let userId = localStorage.getItem('id')
            if (userId == this.datas.UserId) {
                this.$emit('showModalDelete',this.datas.id)
            }else{
                this.$emit('showModalError')
            }
        },
        startDrag(ev, item) {
            this.$emit('start-drag',ev, item)
        },
    }
};
</script>

<style scoped>
</style>